import React, { useMemo, useState } from 'react';
import PersonalInfo from 'apps/user/GetStarted/PersonalInfo';
import {
  IGetStarted,
  IPassword,
  IPersonalInfo,
  IQuestion,
  IQuestionTwo,
  InitialValues
} from 'apps/user/types/get-started.type';
import QuestionOne from 'apps/user/GetStarted/QuestionOne';
import QuestionTwo from 'apps/user/GetStarted/QuestionTwo';
import Plan from 'apps/user/GetStarted/Plan';
import SetupPassword from 'apps/user/GetStarted/SetupPassword';
import Payment from 'apps/user/GetStarted/Payment';
import Successful from 'apps/user/GetStarted/Successful';
import { services } from 'service';
import { toast } from 'react-toastify';
import { Alert } from 'components/Toast';
import { determineRecommendedPlan } from 'utils';
import { useGetPlans } from 'common/queries-and-mutations/payment';

export default function CreateAccount() {
  const [page, setPage] = useState('personal');
  const [formValue, setFormValues] = useState<IGetStarted>(InitialValues);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [accountCreated, setAccountCreated] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isRegisterError, setIsRegisterError] = useState(false);
  const { data: plans } = useGetPlans();

  const onPersonalInfoSubmit = (args: IPersonalInfo) => {
    setPage('question-one');
    setFormValues({ ...formValue, ...args });
  };

  const onQuestionOneSubmit = (args: IQuestion) => {
    setPage('question-two');
    setFormValues({ ...formValue, ...args });
  };

  const onQuestionTwoSubmit = (args: IQuestionTwo) => {
    setPage('plan');
    setFormValues({ ...formValue, ...args });
  };

  const onPlanSubmit = (planId: number, planAmount: number) => {
    setPage('set-password');
    setFormValues({ ...formValue, planId, planAmount });
  };

  const onPasswordSubmit = (args: IPassword) => {
    setPage('payment');
    setFormValues({ ...formValue, ...args });
  };

  const onPaymentSuccess = async (reference: string) => {
    setIsProcessing(true);
    //Register user here
    try {
      await services.manageUsersService.createUser({
        ...formValue,
        reference
      });
      setPage('');
      setPaymentSuccess(true);
      setIsRegisterError(false);
    } catch (error: any) {
      setIsRegisterError(true);
      toast.error(<Alert message={error.message} type="error" />);
    }
  };

  useMemo(() => {
    if (paymentSuccess) {
      setTimeout(() => {
        setAccountCreated(true);
        setPaymentSuccess(false);
      }, 6000);
    }
  }, [paymentSuccess]);

  determineRecommendedPlan(formValue, plans ?? []);

  return (
    <div>
      {page === 'personal' && <PersonalInfo onSubmit={onPersonalInfoSubmit} />}
      {page === 'question-one' && (
        <QuestionOne onSubmit={onQuestionOneSubmit} />
      )}
      {page === 'question-two' && (
        <QuestionTwo onSubmit={onQuestionTwoSubmit} />
      )}
      {page === 'plan' && (
        <Plan onSubmit={onPlanSubmit} formValue={formValue} />
      )}
      {page === 'set-password' && (
        <SetupPassword planId={formValue.planId} onSubmit={onPasswordSubmit} />
      )}
      {page === 'payment' && (
        <Payment
          onSubmit={onPaymentSuccess}
          formValue={formValue}
          isProcessing={isProcessing}
          isRegisterError={isRegisterError}
        />
      )}
      {paymentSuccess && (
        <Successful
          title="Payment Successful"
          buttomText="Setting up your dashboard"
          useCustomCss={true}
        />
      )}
      {accountCreated && (
        <Successful
          title="Account Created"
          showActionButton
          actionLink="/on-boarding"
          buttonText="Create your Will Now"
          useCustomCss={true}
        />
      )}
    </div>
  );
}
